import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [polls, setPolls] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancel = false;
    let tries = 0;
    const tick = async () => {
      if (cancel) return;
      tries += 1;
      setPolls(tries);
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid" || data.payment_status === "failed" || data.payment_status === "expired") {
          setStatus(data);
          return;
        }
      } catch (e) {}
      if (tries < 20) {
        setTimeout(tick, 2000);
      } else {
        setStatus({ payment_status: "pending" });
      }
    };
    tick();
    return () => { cancel = true; };
  }, [sessionId]);

  const isPaid = status?.payment_status === "paid";
  const isFailed = status && !isPaid && status.payment_status !== "pending";
  const loading = !status;

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] p-4">
      <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-2xl p-8 text-center">
        {loading && (
          <>
            <Loader2 className="w-14 h-14 text-emerald-300 mx-auto animate-spin" />
            <div className="mt-6 font-display font-black text-2xl uppercase">
              Vérification du paiement…
            </div>
            <div className="mt-2 text-sm text-slate-400 font-mono-stat">
              Tentative {polls}/20
            </div>
          </>
        )}
        {isPaid && (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto" />
            <div className="mt-6 font-display font-black text-3xl uppercase">
              Paiement confirmé !
            </div>
            <div className="mt-2 text-sm text-slate-400">
              Merci pour votre cotisation.
            </div>
            <button
              data-testid="success-back"
              onClick={() => nav("/paiement")}
              className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white font-bold uppercase tracking-wide"
            >
              Mes paiements <ArrowRight className="w-4 h-4" />
            </button>
          </>
        )}
        {isFailed && (
          <>
            <XCircle className="w-16 h-16 text-rose-400 mx-auto" />
            <div className="mt-6 font-display font-black text-3xl uppercase">
              Paiement non confirmé
            </div>
            <div className="mt-2 text-sm text-slate-400">
              Statut : {status.payment_status}
            </div>
            <button
              onClick={() => nav("/paiement")}
              className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold uppercase tracking-wide"
            >
              Retour
            </button>
          </>
        )}
      </div>
    </div>
  );
}
